import React, { useEffect, useState, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Button, Logo } from 'components'
import { Link, useNavigate } from 'react-router-dom'
import styles from './index.module.css'
import {
    certFromUrlState,
    detailResultDataState,
    reqCdState,
    certTypeState,
    certFromState,
    transmitRequestSelector,
    selectedOrgsState,
} from './states'
import { consentListState, detailLayerState, listLayerState } from 'views/mydata/manage/states'
import { useRecoilValue, useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil'
import Lib from 'library'
import { NoData } from 'components'
import useCommonIndustry from 'hooks/useCommonIndustry'

const DataResult = () => {

    const App = useApp()
    const navigate = useNavigate()

    const [detailResultData, setDetailResultData] = useRecoilState(detailResultDataState)
    const certType = useRecoilValue(certTypeState)
    const resetCertType = useResetRecoilState(certTypeState)
    const reqCd = useRecoilValue(reqCdState)
    const certFrom = useRecoilValue(certFromState)
    const resetCertFrom = useResetRecoilState(certFromState)
    const resetReqCd = useResetRecoilState(reqCdState)
    const resetShowDetailLayer = useResetRecoilState(detailLayerState)
    const resetShowListLayer = useResetRecoilState(listLayerState)
    const resetTransmitRequest = useResetRecoilState(transmitRequestSelector)

    const [certFromUrl, setCertFromUrl] = useRecoilState(certFromUrlState);

    const [data, setData] = useState()
    const [count, setCount] = useState()
    const [successCount, setSuccessCount] = useState()
    const [failCount, setFailCount] = useState()
    const industries = useCommonIndustry()
    const isRetry = useRef(false)

    const retry = () => {
        isRetry.current = true
        navigate("/data/transmitRequest")
    }


    const makeDetailResultData = () => {
        if (typeof detailResultData === "undefined") return

        if (certType === 0 || certType === 1 || certType === 9999) { // 공동, 사설 인증
            
            // org
            // {
            //     "insttCd":"A1AAEO0000",
            //     "insttNm":"KB국민은행",
            //     "indstCd":"bank",
            //     "targetInfoList":[]
            // }
            // 실패 아래 추가됨.
            // "sucesYn":"N",
            // "errDesc":"연동 처리 중 오류가 발생했습니다.",

           
            // 해당 org의 targetinfoList가 빈 리스트면 자산 미보유로 처리 => errDesc 자산미보유
            
            // 단, org자체에 sucesYn가 존재하고 'N'의 경우는 org의 errDesc값을 노출(키값이 없는 케이스 대비하여 "연동 실패"로 null체크)
            
            // targetInfoList 
            // 1. null : 에러 발생
            // 2. empty : 자산 미보유(asset이 없고 sucesYn이 N인 경우들만 존재할 경우 empty arrat로 바꾼다.) => errDesc 자산미보유
            // 3. 존재 : 자산없는 asset은 서버에서 내려주지 않는 것으로.. 단순 노출 진행
            const newList = []
            let scount = 0, fcount = 0, acount = 0
            detailResultData.forEach(org => {
                let found = newList.find(row => row.indstCd === org.indstCd)
                if (!found) {
                    found = {
                        indstCd: org.indstCd,
                        data: []
                    }
                    newList.push(found)
                }

                // if (Lib.isNull(org.targetInfoList)) {
                //     const assetList = Lib.deepCopy(org);

                //     assetList.targetInfoListNull = true;
                //     assetList.targetInfoList = [{ assetList: [org] }]
                //     org = assetList;
                // }
                const assetList = Lib.deepCopy(org);
                if(assetList.sucesYn === "N" 
                    && Lib.isNull(assetList.targetInfoList)
                ) {
                    // 상대기관 응답오류
                    // fcount++ // 실패 카운팅 추가
                    // 토큰 발급 실패, 기관 응답 오류 => 미보유로 셋팅을 하기 위해 카운팅 하지 않고 처리 진행
                    assetList.errDesc = '자산 미보유'
                    assetList.sucesYn = 'N'
                    assetList.targetInfoList = []

                
                }else if(Lib.isNotNull(assetList.targetInfoList) 
                    && Array.isArray(assetList.targetInfoList)
                     && assetList.targetInfoList.length === 0){
                    // 모든 자산이 미보유 상태 
                    assetList.errDesc = '자산 미보유'
                    assetList.sucesYn = 'N'
                    console.log("assetList", assetList)
                }else {

                    assetList.targetInfoList.forEach(item => {
                        item.assetList.forEach(item => {
                            if (item.sucesYn === "Y") {
                                scount++
                            } else if (item.sucesYn === "N" && item.asset && item.asset !== '') {
                                fcount++
                            }
                            acount++
                        })
                    })
                }

                found.data.push(assetList)
                
            })

            setData(newList)
            setCount(acount)
            setSuccessCount(scount)
            setFailCount(fcount)
        } else if (certType === 2) { // 개별인증
            console.log({ detailResultData })
            const asset = detailResultData[0]
            if (asset.sucesYn === "Y") {
                setSuccessCount(1)
            } else {
                setFailCount(1)
            }
            setCount(1)
            setData([
                {
                    indstCd: asset.indstCd,
                    count: 1,
                    data: [{
                        insttNm: asset.insttNm,
                        insttCd: asset.insttCd,
                        targetInfoList: [
                            {
                                asset_list: [
                                    {
                                        assetNm: asset.infNm,
                                        assetTpNm: asset.infTpNm,
                                        asset: asset.infId,
                                        sucesYn: asset.sucesYn,
                                        seqno: ""
                                    }
                                ]
                            }
                        ]
                    }]
                }
            ])
        }
    }


    useEffect(makeDetailResultData, [detailResultData])

    const getIndividualResultData = () => {
        Lib.get(`/api/data/v2/lnkup/rslt/${reqCd}`, data => {
            setDetailResultData(data);
        })
    }

    useEffect(() => {
        if (reqCd && !App.test) getIndividualResultData()
    }, [reqCd])

    useEffect(() => {
        App.setHeader({
            show: true,
            title: <></>,
            left: "",
            right: undefined
        })

        App.setShowNav(false)
        App.setMainClass("white")
        
        return () => {
            resetReqCd()
            resetShowDetailLayer()
            resetShowListLayer()
            resetTransmitRequest()
            if (!isRetry.current) {
                resetCertType()
                resetCertFrom()
            }
        }
    }, [])

    return (
        <div className="page">
            <div className="flex_1 padding">
                {
                    certFrom === "extend" &&
                    <div className={styles["count-group"]}>
                        <p>전송요구 종료시점이 연장되었습니다.</p>
                    </div>
                    ||
                    certFrom === "modify" &&
                    <div className={styles["count-group"]}>
                        <p>전송요구 종료시점이 변경되었습니다.</p>
                    </div>
                    ||
                    <div className={styles["count-group"]}>
                        <p>연결 결과</p>
                        <div><span>4</span>/4</div>
                    </div>
                }
                <div className="mt_20">
                    <div className="">
                        {
                            data ?
                                (
                                    data.length > 0 ?
                                        (data.map((industry, index) => {
                                            return (
                                                <div key={index}>
                                                    <div style={{ fontSize: "1.6rem", fontWeight: 500 }}
                                                        className={index > 0 ? "mt_30" : undefined}>{industries && (() => {
                                                            const found = industries.find(item => item.commCd.toLowerCase() === industry.indstCd)
                                                            if (found) {
                                                                if(found.commCd.toLowerCase() === "kinfa") {
                                                                    return "공공기관"
                                                                }else{
                                                                return found.commNm}
                                                            }
                                                        })()}</div>
                                                    {
                                                        industry.data.map((org, index) => {
                                                            return (
                                                                <div key={index}
                                                                    className={`block ${index > 0 ? "mt_20" : "mt_10"}`}>
                                                                        {/* 기관 로고와 명칭은 노출한다. */}
                                                                        <div
                                                                            className="flex-align_center"
                                                                            style={{width: "100%"}}>
                                                                            <div
                                                                                className="img-box img-symbol">
                                                                                <Logo code={org.insttCd}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%"
                                                                                    }} />
                                                                            </div>
                                                                            <div className={
                                                                                    ((org.targetInfoList && org.targetInfoList.length === 0) || org.sucesYn === "N" )
                                                                                    ? 'ml_10 flex-align_center justify_between' 
                                                                                    : 'ml_10'
                                                                                }
                                                                                style={{width: "100%"}}>
                                                                                <p>{org.insttNm}</p>
                                                                                {
                                                                                    ((org.targetInfoList && org.targetInfoList.length === 0) || org.sucesYn === "N")  &&
                                                                                    <span
                                                                                    className="text-red nowrap">{org.errDesc ?? 'defaultMessage'}</span>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    { org.targetInfoList && org.targetInfoList.length > 0 &&
                                                                        org.targetInfoList.map((target, index) => {
                                                                            return (
                                                                                <div key={index}>
                                                                                  

                                                                                    <ul className="mt_5"
                                                                                        style={{ lineHeight: 2 }}>
                                                                                        {
                                                                                            target.assetList.map((asset, index) => {
                                                                                                return (
                                                                                                    Lib.isNotNull(asset.asset) &&
                                                                                                    <li key={index}
                                                                                                        className="flex-justify_between">
                                                                                                        <span
                                                                                                            className="ellipsis mr_10">
                                                                                                            {
                                                                                                                asset.assetTpNm &&
                                                                                                                
                                                                                                                <>
                                                                                                                    <i className={`tag mr_10 ${(() => {
                                                                                                                        switch (asset.assetTpNm) {
                                                                                                                            case "자유입출식":
                                                                                                                                return "tag-purple"
                                                                                                                            case "신용":
                                                                                                                                return "tag-sky"
                                                                                                                            case "휴대폰":
                                                                                                                                return "tag-pink"
                                                                                                                            default:
                                                                                                                                return "tag-blue"
                                                                                                                        }
                                                                                                                    })()
                                                                                                                        }`}>{asset.assetTpNm}</i>
                                                                                                                    {(Lib.isNotNull(asset.assetNm) ? asset.assetNm : asset.asset)}
                                                                                                                </>
                                                                                                            }
                                                                                                        </span>
                                                                                                        {
                                                                                                            asset.assetTpNm &&
                                                                                                            
                                                                                                            <span>
                                                                                                                {
                                                                                                                    asset.assetTpNm &&
                                                                                                                    asset.sucesYn === "Y" &&
                                                                                                                    <span
                                                                                                                        className="text-blue nowrap">성공</span>
                                                                                                                }
                                                                                                                 {   asset.sucesYn === "N" &&
                                                                                                                    <span
                                                                                                                        className="text-red nowrap">실패</span>
                                                                                                                }
                                                                                                            </span>}
                                                                                                    </li>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </ul>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                        )
                                        :
                                        <NoData />
                                )
                                :
                                <div className="skeleton" />
                        }
                    </div>
                </div>
            </div>
                <div className="flex-shrink_0 padding btn-group flex-full">
             
                    {
                        (successCount > 0 && failCount > 0) &&
                        <Button className="btn btn--big btn--gray" onClick={retry}>재시도</Button>
                    }
                    {
                        (successCount === count  && count > 0)&&
                        <Link to="/data"><Button className="btn btn--big btn--gray">추가연결</Button></Link>
                    }
                    {
                        (failCount === count && count > 0) &&
                        <Link to="/"><Button className="btn btn--big btn--gray">다음에</Button></Link>
                    }
                    {
                        successCount > 0 &&
                        <Button className="btn btn--big ml_10" onClick={() => { setCertFromUrl("/mydata"); navigate(certFromUrl); }}>확인하러 가기</Button>
                    }
                    {
                        (failCount === count && count > 0)&&
                        <Button className="btn btn--big ml_10" onClick={retry}>재시도</Button>
                    }
                    {
                         count === 0 &&
                        <Link to="/"><Button className="btn btn--big btn--gray">홈으로</Button></Link>
                    }
                
                </div>
        </div>
    )
}

export default DataResult